import React from "react";
import { Profile } from "../../util/profile.util";
import { AvatarCluster } from "./AvatarCluster";
import { Item } from "./Item";

export type ColoredProfile = {
  color: string;
  profile: Profile;
};

export const Event: React.FC<{ coloredProfiles: (ColoredProfile | null)[] }> = ({
  children,
  coloredProfiles,
}) => {
  return (
    <Item
      right={<div className="cw-body-sm">{children}</div>}
      left={
        <div className="cw-w-8 cw-h-8 cw-bg-neutral cw-flex cw-items-center cw-justify-center">
          <AvatarCluster coloredProfiles={coloredProfiles} />
        </div>
      }
    />
  );
};
